exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-complete-enter[data-v-0c7fcfd5], .list-complete-leave-to[data-v-0c7fcfd5] {\n    opacity: 0;\n}\n.list-complete-leave[data-v-0c7fcfd5] {\n    -webkit-transition: opacity .5s;\n    transition: opacity .5s;\n}\n.list-complete-enter-to[data-v-0c7fcfd5] {\n    -webkit-transition: opacity 1.5s;\n    transition: opacity 1.5s;\n}\n", ""]);

// exports
